import {useEffect, useState} from 'react'

import {useFormik} from 'formik'
import {Button, Container, Form as BootstrapForm, Modal, Pagination} from 'react-bootstrap'
import * as Yup from 'yup'
import {toast} from 'react-toastify'

import {KTCard, KTCardBody, KTIcon} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
/* import {UsersListHeader} from '../../modules/apps/user-management/users-list/components/header/UsersListHeader'
import {Column, ColumnInstance, Row, useTable} from 'react-table'
import {UserCustomHeader} from '../../modules/apps/user-management/users-list/table/columns/UserCustomHeader'
import {UserInfoCell} from '../../modules/apps/user-management/users-list/table/columns/UserInfoCell'
import {UserActionsCell} from '../../modules/apps/user-management/users-list/table/columns/UserActionsCell'
import {UsersListToolbar} from '../../modules/apps/user-management/users-list/components/header/UserListToolbar'
import {CustomHeaderColumn} from '../../modules/apps/user-management/users-list/table/columns/CustomHeaderColumn'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {CustomRow} from '../../modules/apps/user-management/users-list/table/columns/CustomRow' */
// import {UsersListPagination} from '../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import {useMutation, useLazyQuery} from '@apollo/client'
import {GET_ALL_CANTERAS} from '../../graphql/queries/canteras'
import {Spinner} from '../../components/Spinner'
import {Edge, ICanteras, IResCreateUpdateCantera} from '../../graphql/types/canterasTypes'
import {useGetUser} from '../../hooks/useGetUser'
import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {CREATE_UPDATE_CANTERA} from '../../graphql/mutations/canteraMutations'
import {hasPermission, parseId} from '../../helpers'
import {ALL_PERMISSIONS} from '../../helpers/consts'

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Este campo es requerido'),
  address: Yup.string().required('Este campo es requerido'),
  phoneNumber: Yup.string().required('Este campo es requerido'),
  description: Yup.string(),
})

export const CanterasPage = () => {
  const [gqlGetAllCanteras, {data, loading, error, refetch}] = useLazyQuery<ICanteras>(
    GET_ALL_CANTERAS,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const [gqlCreateUpdateCantera, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<IResCreateUpdateCantera>(CREATE_UPDATE_CANTERA)

  const [searchTerm, setSearchTerm] = useState('')
  const [showModalCreateUpdate, setShowModalCreateUpdate] = useState(false)
  const [idCanteraEdit, setIdCanteraEdit] = useState<null | string>(null)
  const [offset, setOffset] = useState(0)
  const [isPagination, setIsPagination] = useState(false)
  const [pagePag, setPagePag] = useState(1)
  const [dataArr, setDataArr] = useState<Edge[]>([])

  const {/* idOrganization, */ user} = useGetUser()

  const formik = useFormik({
    initialValues: {
      name: '',
      address: '',
      phoneNumber: '',
      description: '',
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values)
      // console.log('idOrganization', idOrganization)
      // if (!idOrganization) return
      gqlCreateUpdateCantera({
        variables: {
          input: {
            ...values,
            id: idCanteraEdit ? parseId(idCanteraEdit) : undefined,
            // organization: parseId(idOrganization),
          },
        },
      })
    },
  })

  useEffect(() => {
    gqlGetAllCanteras({
      variables: {
        offset,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset])

  useEffect(() => {
    if (error) {
      console.log('error', error)
    }
  }, [error])

  useEffect(() => {
    if (!data) return
    if (isPagination) {
      const end = parseId(data?.quarryList.pageInfo?.endCursor || '0')
      console.log('end', end)
      const pageNew = (end + 1) / 10 + 1
      setDataArr((prev) => [...prev, ...data.quarryList.edges])
      setPagePag(Math.floor(pageNew))
      return
    }
    setDataArr(data.quarryList.edges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (!dataCreate) return
    if (dataCreate.quarryCreateUpdate.quarry?.id) {
      toast.success(`Cantera ${idCanteraEdit ? 'actualizada' : 'creada'} con éxito`)
      setIsPagination(false)
      setOffset(0)
      setPagePag(1)
      refetch()
      setShowModalCreateUpdate(false)
      formik.resetForm()
    } else if (dataCreate?.quarryCreateUpdate.errors?.length > 0) {
      console.log('noooo')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])

  useEffect(() => {
    if (errorCreate) {
      console.log('errorCreate', errorCreate)
    }
  }, [errorCreate])

  const handleClose = () => {
    setShowModalCreateUpdate(false)
  }

  if (loading && !isPagination) {
    return (
      <div>
        <PageTitle
          breadcrumbs={[
            {
              title: 'CMR',
              path: '/',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
        >
          Lista de canteras
        </PageTitle>
        <KTCard>
          <div style={{height: '40vh'}}>
            <KTCardBody className='py-4 d-flex align-items-center justify-content-center h-100'>
              <Spinner />
            </KTCardBody>
          </div>
        </KTCard>
      </div>
    )
  }
  if (!data && !isPagination) return null
  const canterasList = dataArr

  const permissions = user?.tokenAuth.permissions ?? ['']

  return (
    <div>
      <BreadcrumbJeisat
        title='Lista de canteras'
        breadcrumb={[
          {
            title: 'CRM',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <>
            {hasPermission(permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_CANTERA) ? (
              <Button
                onClick={() => {
                  setShowModalCreateUpdate(true)
                  setIdCanteraEdit(null)
                }}
                className='d-flex align-items-center gap-1'
              >
                <i className='fa fa-plus' /> Agregar cantera
              </Button>
            ) : null}
          </>
        }
      />

      <KTCard>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            {/* begin::Search */}
            <div className='d-flex align-items-center position-relative my-1'>
              <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Buscar cantera'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            {/* end::Search */}
          </div>
          {/* begin::Card toolbar */}
          {/*  <div className='card-toolbar'>
            {/* begin::Group actions
            <UsersListToolbar />
            {/* end::Group actions 
          </div> */}
          {/* end::Card toolbar */}
        </div>
        <KTCardBody className='py-4'>
          <div className='table-responsive'>
            <table
              id='kt_table_users'
              className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
            >
              <thead className='fw-bold'>
                <tr className='text-start text-gray-900 fw-bold fs-7 text-uppercase gs-0'>
                  <th>Nombre</th>
                  <th>Dirección</th>
                  <th>Teléfono</th>
                  <th>Descripción</th>
                  <th />
                </tr>
              </thead>
              <tbody className='text-gray-700'>
                {canterasList.length > 0 ? (
                  canterasList
                    .filter(({node}) => {
                      if (searchTerm.length < 3) return true
                      return node.name.includes(searchTerm)
                    })
                    .slice(10 * (pagePag - 1), pagePag * 10)
                    .map(({node}) => (
                      <tr key={node.id}>
                        <td>{node.name}</td>
                        <td>{node.address}</td>
                        <td>{node.phoneNumber}</td>
                        <td style={{maxWidth: '130px'}} className='truncate-jeiset'>
                          {node.description}
                        </td>
                        <td>
                          <button
                            className='border-0 p-0 m-0 bg-transparent me-4 hover-bg-color-dark text-secondary'
                            onClick={() => {
                              setIdCanteraEdit(node.id)
                              formik.setValues({
                                address: node.address,
                                description: node.description,
                                name: node.name,
                                phoneNumber: node.phoneNumber,
                              })
                              setShowModalCreateUpdate(true)
                            }}
                            title='Editar'
                          >
                            <i className='fa fa-pencil' style={{color: 'inherit'}} />
                          </button>
                          {/* <button
                          className='border-0 p-0 m-0 bg-transparent hover-bg-color-dark text-secondary'
                          onClick={() => setIdCanteraEdit(node.id)}
                          title='Ver'
                        >
                          <i className='fa fa-eye' style={{color: 'inherit'}} />
                        </button> */}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No hay canteras registradas
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {loading && isPagination && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Spinner size='24px' />
            </div>
          )}
          <div className='row'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <Pagination>
                <Pagination.Prev
                  disabled={pagePag === 1}
                  onClick={() => setPagePag((pre) => pre - 1)}
                />
                {data?.quarryList.pageInfo?.endCursor &&
                  Array.from(
                    {length: Math.ceil((parseId(data.quarryList.pageInfo.endCursor) + 1) / 10)},
                    (_, i) => i + 1
                  ).map((ind) => (
                    <Pagination.Item
                      onClick={() => {
                        setPagePag(ind)
                      }}
                      key={ind}
                      active={ind === pagePag}
                    >
                      {ind}
                    </Pagination.Item>
                  ))}
                <Pagination.Next
                  disabled={!data?.quarryList.pageInfo.hasNextPage}
                  onClick={() => {
                    setOffset((pre) => pre + 10)
                    setIsPagination(true)
                  }}
                />
              </Pagination>
            </div>
          </div>
          {/* {isLoading && <UsersListLoading />} */}
        </KTCardBody>
      </KTCard>

      <Modal show={showModalCreateUpdate} onHide={handleClose}>
        <BootstrapForm onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>{idCanteraEdit ? 'Editar cantera' : 'Crear cantera'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <BootstrapForm.Group controlId='name' className='mb-2'>
                <BootstrapForm.Label>
                  Nombre<span style={{color: 'red'}}>*</span>
                </BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  name='name'
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.name && formik.touched.name && (
                  <BootstrapForm.Text className='text-danger'>
                    {formik.errors.name}
                  </BootstrapForm.Text>
                )}
              </BootstrapForm.Group>

              <BootstrapForm.Group controlId='address' className='mb-2'>
                <BootstrapForm.Label>
                  Dirección<span style={{color: 'red'}}>*</span>
                </BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  name='address'
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.address && formik.touched.address && (
                  <BootstrapForm.Text className='text-danger'>
                    {formik.errors.address}
                  </BootstrapForm.Text>
                )}
              </BootstrapForm.Group>

              <BootstrapForm.Group controlId='phoneNumber' className='mb-2'>
                <BootstrapForm.Label>
                  Número de Teléfono<span style={{color: 'red'}}>*</span>
                </BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  name='phoneNumber'
                  value={formik.values.phoneNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.phoneNumber && formik.touched.phoneNumber && (
                  <BootstrapForm.Text className='text-danger'>
                    {formik.errors.phoneNumber}
                  </BootstrapForm.Text>
                )}
              </BootstrapForm.Group>

              <BootstrapForm.Group controlId='description' className='mb-2'>
                <BootstrapForm.Label>Descripción</BootstrapForm.Label>
                <BootstrapForm.Control
                  as='textarea'
                  name='description'
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </BootstrapForm.Group>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type='button'
              variant='secondary'
              onClick={() => {
                handleClose()
                formik.resetForm()
              }}
            >
              Cancelar
            </Button>
            <Button
              type='submit'
              variant='primary'
              disabled={loadingCreate}
              className='d-flex align-items-center gap-2'
            >
              {loadingCreate && <Spinner color='light' size='14px' />}
              {/* <Spinner color='light' size='14px' /> */}
              {idCanteraEdit ? 'Editar' : 'Crear cantera'}
            </Button>
          </Modal.Footer>
        </BootstrapForm>
      </Modal>
    </div>
  )
}
